module.exports = __webpack_public_path__ + "img/map-controls.30730e69.png";